import { isBrowser } from '../constants';
import { publicApi } from './index';

export const lockFileAPI = async (
  uuid: string,
  contractAddress: string,
  tokenType: string,
  gateBalance: number,
  name: string,
  image: string,
  recaptchaToken: string
) => {
  const data = {
    token: {
      contractAddress,
      name,
      image,
      tokenType,
      gateBalance: Number(gateBalance),
    },
  };
  return publicApi.post(
    `/file/${uuid}/edit`,
    data,
    isBrowser && localStorage.getItem('token')
      ? {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            RecaptchaToken: recaptchaToken,
          },
        }
      : {}
  );
};
